import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from 'config/i18n';
import { Localestype } from 'models/types';
import { RootState } from '../../app/store';

interface OptionsSlice {
  selectedLocale: Localestype;
  isLTR: boolean;
}

const initialState: OptionsSlice = {
  selectedLocale: 'fa',
  isLTR: false,
};

export const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {
    selectLocale: (state, action: PayloadAction<Localestype>) => {
      let route = window.location.pathname.split('/');
      if (route[2] !== action.payload) {
        route.splice(2, 1, action.payload);
        window.location.replace(route.join('/'));
      } else {
        i18n.changeLanguage(action.payload);
        state.isLTR = action.payload === 'fa' ? false : true;
        state.selectedLocale = action.payload;
      }
    },
  },
});

export const { selectLocale } = optionsSlice.actions;

export const selectedLocale = (state: RootState) => state.options.selectedLocale;
export const isLTRState = (state: RootState) => state.options.isLTR;

export default optionsSlice.reducer;
